'use client';
import apiClient from './apiClient';

/** 任務中心相關 */
class MissionClient {
    // 星塵任務狀態
    getMissionReport = () => apiClient.get(`/stardust/mission-report`);
    // 領取任務點數
    claimMission = (missionId: number): Promise<any> =>
        apiClient.post(`/stardust/draw-mission-reward/${missionId}`);
    // 記錄任務「去完成」按鈕的點擊（所有任務類型，供點擊率報表）；
    // 追蹤社群平台(follow_social)點擊即算達成，會回傳更新後報表
    recordMissionClick = (missionId: number): Promise<any> =>
        apiClient.post(`/stardust/missions/${missionId}/click`);
}

const missionClient = new MissionClient();

export default missionClient;
